// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import {
    VIRTUAL_SERVER_FOOTER_VIEW_CLASS_NAME,
} from "../../../../../core/constants/className";
import { ProductArticle } from "../../../common/productArticle/ProductArticle";
import {
    SUPPORT_IMAGE,
} from "../../../../assets/images";
import {
    T_SITE_NAME,
    T_VIRTUALSERVERS_FOOTER_BUTTON_TEXT,
    T_VIRTUALSERVERS_FOOTER_DESCRIPTION,
    T_VIRTUALSERVERS_FOOTER_TITLE,
} from "../../../../../core/constants/translation";
import {
    CUSTOMER_SERVICE_ROUTE,
    VIRTUALSERVER_FOOTER_ROUTE,
} from "../../../../../core/constants/route";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";
import { SEODiv } from "../../../common/seo/SEODiv";
import "./VirtualServerFooterView.scss";

export interface VirtualServerFooterViewProps {
    readonly t: TranslationFunction;
    readonly className ?: string;
}

export function VirtualServerFooterView (props: VirtualServerFooterViewProps) {

    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;

    const description :  Array<any> = [
        `${T_VIRTUALSERVERS_FOOTER_DESCRIPTION}`,
    ];

    return (
        <SEODiv
            className={
                VIRTUAL_SERVER_FOOTER_VIEW_CLASS_NAME + (className ? ` ${className}` : "")
            }
            path={VIRTUALSERVER_FOOTER_ROUTE}
            title={t(T_VIRTUALSERVERS_FOOTER_TITLE)}
            description={t(T_VIRTUALSERVERS_FOOTER_DESCRIPTION)}
            siteName={t(T_SITE_NAME)}
        >

            <ProductArticle
                t={t}
                className="view"
                previewImage={SUPPORT_IMAGE}
                title={t(T_VIRTUALSERVERS_FOOTER_TITLE)}
                description={description}
                secondaryButtonTo={CUSTOMER_SERVICE_ROUTE}
                secondaryButtonText={t(T_VIRTUALSERVERS_FOOTER_BUTTON_TEXT)}
            />
        </SEODiv>
    );

}
